/**
 * Created by jv on 2019-09-26 (15:56).
 */
const log = require("Sources/utils/logger")();
import utils from "Sources/utils/utils";
import LanguageManager from "Sources/services/language-manager";
import InvestmentSlider from "Sources/components/game/components/investment-slider";

const CloseSvgIcon = require("!raw-loader!Images/icons/btn_plus.svg");

require("Styles/components/investment-card.scss");
require("Styles/components/business-model-dialog.scss");
require("Styles/components/investment-dialog.scss");

class InvestmentDialog {
  constructor(options) {
    this.dialogId = utils.generateElementId("investment-dialog-");
    this.investment = options.investment;

    this.team = options.team;
    this.roundOverview = options.roundOverview;
    this.investments = options.investments;

    this.callbackContext = options.callbackContext;
    this.onCancel = options.onCancel;
    this.onViewExampleCases = options.onViewExampleCases;
    this.onPreview = options.onPreview;
    this.onPurchase = options.onPurchase;
  }

  get currentRoundData() {
    return this.roundOverview.currentRoundData;
  }

  get isOpen() {
    return utils.isNotNull(this.$dialog) && this.$dialog.length && this.$dialog.hasClass("show");
  }

  create() {
    if (this._initialized !== true) {
      this.renderDialog();

      this.$dialog.appendTo("body");
      this.initialize();
    }
  }

  initialize() {
    if (this._initialized !== true) {
      this.$dialog.modal({
        backdrop: false,
        show: false
      });

      this.setUpDialogEventListeners();

      this._initialized = true;
    }
  }

  renderDialog() {
    this.$dialog = $("<div id='" + this.dialogId + "' class='modal fade' tabindex='-1' role='dialog' aria-hidden='true'>" +
      "<div class='modal-dialog modal-dialog-centered business-model-dialog investment-dialog'>" +
      "<div class='modal-content'>" +
      "</div>" +
      "</div>" +
      "</div>");

    this.renderDialogContent();
  }

  renderDialogContent() {
    if (utils.isNull(this.investment)) return;

    let $dialogContent = this.$dialog.find(".modal-content");

    if (utils.isNotNull($dialogContent) && $dialogContent.length) {
      $dialogContent.empty();

      log.debug("Setting up investment dialog card for investment - %o", this.investment);

      let $closeBtn = $("<button class='btn dialog-close-btn' type='button'></button>");
      $closeBtn.html(CloseSvgIcon);
      $dialogContent.append($closeBtn);

      let $investmentCardWrapper = $("<div class='ic__wrapper'></div>");

      let $investmentCardBack = $("<div class='investment-card investment-card__back'></div>");
      $investmentCardBack.attr("data-investment-key", this.investment.key);
      $investmentCardBack.attr("data-investment-type", this.investment.type);
      $investmentCardBack.attr("data-investment-category", this.investment.category);
      $investmentCardBack.addClass(`ic__type-${this.investment.type}`);

      let $cardTop = $("<div class='investment-card__top'></div>");

      let $investmentCost = $("<div class='ic__cost'></div>");
      // NOTE: cost "-1" means that the cost == current round
      let investmentCost = InvestmentSlider.getCostForInvestment(this.roundOverview, this.investment);
      let $investmentCostValue = $("<div class='ic-data ic-data__budget'></div>");

      if (this.investment.cost === -1) {
        $investmentCost.addClass("ic__dynamic-cost");
        $investmentCostValue.append("<span class='ic__dynamic-cost-label'>R</span>").append(`<span class="ic__dynamic-cost-value">${investmentCost}</span>`);
      } else {
        $investmentCostValue.text(investmentCost);
      }

      $investmentCost.append($investmentCostValue);

      if (this.investment.redesignNeeded) {
        $investmentCost.append("<div class='ic-data ic-data__research'></div>");
      }

      $investmentCost.append(`<div class='ic__cost-label'>${LanguageManager.getValueForKey("serious_game.business_model.investments.cost.label")}</div>`);
      $cardTop.append($investmentCost);

      let $investmentIcon = $("<div class='ic__icon'></div>").html(InvestmentSlider.getIconCardForInvestment(this.investment.type, false));
      $cardTop.append($investmentIcon);

      // $cardTop.append(`<h5 class='ic__title'>${utils.escapeHtml(investment.title)}</h5>`);
      let investmentTitle = LanguageManager.getValueForKey(`serious_game.business_model.investments.back.titles.${this.investment.type}`);
      $cardTop.append(`<h5 class='ic__title'>${investmentTitle}</h5>`);
      $cardTop.append(`<p class='ic__description'>${utils.escapeHtml(this.investment.description)}</p>`);

      let $cardBottom = $("<div class='investment-card__bottom'></div>");
      let $investmentActions = $("<div class='ic__actions'></div>");

      let $showExamplesBtn = $(`<button class='btn btn-outline-c-green btn-lg example-cases-btn' type='button'>${LanguageManager.getValueForKey("serious_game.business_model.investments.actions.examples_btn")}</button>`);
      $showExamplesBtn.prop("disabled", this.investment.examples.length === 0);
      $investmentActions.append($showExamplesBtn);

      $investmentActions.append(`<button class='btn btn-outline-c-light-blue btn-lg preview-investment-btn' type='button'>${LanguageManager.getValueForKey("serious_game.business_model.investments.actions.preview_btn")}</button>`);

      let $purchaseBtn = $(`<button class='btn btn-outline-c-yellow btn-lg purchase-investment-btn' type='button'>${LanguageManager.getValueForKey("serious_game.business_model.investments.actions.purchase_btn")}</button>`);

      // Has enough budget AND hasn't purchased 2 investments
      let canPurchase = InvestmentSlider.canPurchaseInvestment(this.team, this.roundOverview, this.investments, this.investment);
      $purchaseBtn.prop("disabled", !canPurchase);

      $investmentActions.append($purchaseBtn);

      $cardBottom.append($investmentActions);

      $investmentCardBack.append($cardTop).append($cardBottom);
      $investmentCardWrapper.append($investmentCardBack);
      $dialogContent.append($investmentCardWrapper);

      this.setUpInvestmentEventListeners();
    }
  }

  setPurchaseButtonLoading(flag) {
    let $purchaseBtn = this.$dialog.find(".purchase-investment-btn");
    $purchaseBtn.removeClass("btn-loading").prop("disabled", flag);

    if (flag) {
      $purchaseBtn.addClass("btn-loading");
    }
  }

  show() {
    this.cancelShow = false;
    this.setPurchaseButtonLoading(false);
    this.renderDialogContent();
    this.$dialog.modal("show");
  }

  hide() {
    this.cancelShow = true;
    this.$dialog.modal("hide");
  }

  setUpDialogEventListeners() {
    this.$dialog.on("show.bs.modal", (e) => {
      if (this.cancelShow) {
        this.cancelShow = false;
        e.preventDefault();
      }
    });

    this.$dialog.on("shown.bs.modal", (e) => {
      if (this.cancelShow) {
        this.cancelShow = false;
        this.hide();
      }
    });

    this.$dialog.on("hide.bs.modal", (e) => {
      this.cancelShow = false;
    });

    this.$dialog.on("hidden.bs.modal", (e) => {
      this.cancelShow = false;
    });
  }

  setUpInvestmentEventListeners() {
    this.$dialog.find(".btn").on("transitionend", (e) => {
      // transitionend fix for dialog close animations
      e.preventDefault();
      e.stopPropagation();
      return false;
    });

    this.$dialog.find(".dialog-close-btn").on("click", (e) => {
      if (utils.isFunction(this.onCancel)) {
        this.onCancel.call(this.callbackContext, this);
      }
    });

    this.$dialog.find(".example-cases-btn").on("click", (e) => {
      if (utils.isFunction(this.onViewExampleCases)) {
        this.onViewExampleCases.call(this.callbackContext, this);
      }
    });

    this.$dialog.find(".preview-investment-btn").on("click", (e) => {
      if (utils.isFunction(this.onPreview)) {
        this.onPreview.call(this.callbackContext, this);
      }
    });

    this.$dialog.find(".purchase-investment-btn").on("click", (e) => {
      if (utils.isFunction(this.onPurchase)) {
        this.onPurchase.call(this.callbackContext, this);
      }
    });
  }
}

export default InvestmentDialog;



// WEBPACK FOOTER //
// ./app/js/components/game/components/investment-dialog.js